import React from 'react';
import styled from 'styled-components';
import { AuditLog, Loader } from '@ubeya/shared-web/components';
import useAuditLogs from '@ubeya/shared/hooks/account/useAuditLogs';

const Wrapper = styled.div`
  max-height: 110px;
  overflow: auto;
`;

const AuditLogsContainer = ({ timesheetIds, jobIds, isExternal = false }) => {
  const { data, isLoading } = useAuditLogs({
    timesheetIds,
    jobIds,
    isExternal
  });
  const hasAuditIds = (timesheetIds || [])?.length > 0 || (jobIds || [])?.length > 0;

  if (isLoading) {
    return <Loader />;
  }

  if (!hasAuditIds || !data) {
    return null;
  }

  return (
    <Wrapper>
      {(data || []).map(({ type, data: currentData, ...rest }, index) => (
        <AuditLog key={index} type={type} data={{ data: JSON.parse(currentData), ...rest, type }} />
      ))}
    </Wrapper>
  );
};

export default AuditLogsContainer;
